<template>
  <div>
    <div class="md-layout-item md-size-100">
      <CustomChart
        ref="chart"
        :data="functionData"
        @column-update="getExpensesOrExpenseGroups"
      >
        <template slot="actions">
          <div class="balance-display">
            <h3>Zaduženo: {{ priceDisplay(metaData.totalDebt) }}</h3>
          </div>
        </template>
      </CustomChart>
    </div>
    <div :key="reloading">
      <div ref="expenseContainer" class="md-layout">
        <Expense
          v-if="selectedExpense"
          :type="$route.query.filter ? $route.query.filter : 'expense'"
          :expense="selectedExpense"
          @hideExpense="hideExpense"
          @saveExpense="handleSavedExpense"
        />
      </div>
      <SearchTable
        ref="table"
        @checked="updateInvoiceCheck"
        :header="chooseHeader"
        :key="reloading"
        :queriedData="modifiedExpenses"
        :metaData="metaData"
        :getItems="getExpensesOrExpenseGroups"
        :params="filterParams"
        :sortBy="'dateSigned'"
        :newItem="registerExpense"
        :openItem="openExpense"
        :forEachSelected="forEachSelectedFiltered"
        :individualFunction="[
          {
            function: openDocumentUrl,
            class: 'md-round',
            icon: 'link',
            condition: shouldShowLink,
          },
        ]"
      />
      <div
        class="md-layout-item md-size-100"
        v-if="
          $route.query.filter && $route.query.filter === 'salary' && metaData
        "
      >
        <md-card class="md-layout-item md-size-100">
          <md-card-header class="md-card-header-icon md-card-header-warning">
            <div class="card-icon">
              <md-icon>request_page</md-icon>
            </div>

            <h4 class="title">Plate</h4>
          </md-card-header>
          <md-card-content class="md-layout md-layout-item md-size-85 ml-auto">
            <div class="md-layout align-right">
              <span class="tim-note">
                Ukupna zaduzenja {{ metaData.inAmountToPay }}
              </span>
              <span class="tim-note">
                Ukupno isplata {{ metaData.outAmountToPay }}
              </span>
              <span class="tim-note">
                Saldo {{ metaData.differenceToPay }}
              </span>
            </div>
            <div class="md-layout-item">
              <span class="tim-note">
                Zadnja plata {{ metaData.lastPayment }}
              </span>
              <span class="tim-note">
                Prije
                {{ lastPaymentDaysAgoString }}
              </span>
            </div>
            <h3 class="md-layout-item text-danger align-right">
              {{ metaData.totalSalary }}
            </h3>
            <md-button
              @click="generateSalaryCheckes"
              class="md-warning md-layout-item"
            >
              <span class="text-primary">Zaduži plate</span>
            </md-button>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTable.vue';
import Expense from '@/pages/Expense.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import CustomChart from '@/components/Cards/CustomChart.vue';
import { cases } from '@/utils/helpers';

export default {
  components: {
    SearchTable,
    Expense,
    CustomChart,
  },
  computed: {
    filterTemplates() {
      if (this.$route.query.filter && this.$route.query.filter === 'salary') {
        return null;
      } else {
        return this.templates;
      }
    },
    filterParams() {
      if (this.$route.query?.filter === 'salary') {
        return {
          id: this.params.id,
          clientName: this.params.clientName,
          amountToPay: this.params.amountToPay,
          direction: this.params.direction,
          dateSigned: this.params.dateSigned,
        };
      } else if (this.$route.query?.filter === 'cash') {
        return {
          id: this.params.id,
          clientName: this.params.clientName,
          amountToPay: this.params.amountToPay,
          direction: this.params.direction,
          dateSigned: this.params.dateSigned,
        };
      } else {
        return this.params;
      }
    },
    chooseHeader() {
      if (this.$route.query.filter === 'salary') {
        return {
          title: 'Plate',
          icon: 'euro_symbol',
          class: 'md-card-header-brand',
        };
      } else if (this.$route.query.filter === 'cash') {
        return {
          title: 'Blagajna ulaz',
          icon: 'savings',
          class: 'md-card-header-brand',
        };
      } else {
        return {
          title: 'Ulazne fakture',
          icon: 'arrow_back',
          class: 'md-card-header-brand',
        };
      }
    },
    forEachSelectedFiltered() {
      let forEachSelected = [
        {
          icon: 'delete',
          label: 'Briši',
          class: 'md-danger',
          function: this.deleteExpenses,
        },
      ];
      if (this.canGeneratePayments)
        forEachSelected = [
          {
            icon: 'payments',
            label: 'Isplati',
            class: 'md-primary',
            function: this.generatePayments,
          },
        ].concat(forEachSelected);
      return forEachSelected;
    },
    modifiedExpenses() {
      if (this.$route.query.filter) {
        return this.expenses;
      } else if (this.selectedGroup) {
        let modifiedExpenses = [];
        this.expenseGroups.forEach(expenseGroup => {
          modifiedExpenses.push(expenseGroup);
          if (`G${this.selectedGroup}` === expenseGroup.id) {
            modifiedExpenses = modifiedExpenses.concat(this.expenses);
          }
        });
        return modifiedExpenses;
      } else {
        return this.expenseGroups;
      }
    },
    lastPaymentDaysAgo() {
      if (!this.metaData?.lastPayment) return null;
      return Math.floor(
        (new Date().getTime() - new Date(this.metaData.lastPayment).getTime()) /
          (1000 * 60 * 60 * 24),
      );
    },
    lastPaymentDaysAgoString() {
      if (!this.lastPaymentDaysAgo) return null;
      return `${this.lastPaymentDaysAgo} ${cases(
        this.lastPaymentDaysAgo,
        'dan',
        'dana',
        'dana',
      )}`;
    },
  },
  data() {
    return {
      params: {
        invoiceNumber: null,
        clientName: null,
        expenseType: null,
        dateSigned: [null, null],
        amountToPay: [null, null],
        document: ['empty', 'linked'],
      },
      metaData: null,
      expenses: [],
      expenseGroups: [],
      selectedExpense: null,
      selectedGroup: null,
      reloading: 0,
      canGeneratePayments: false,
      functionData: {
        labels: [],
        series: [],
        legend: [],
      },
    };
  },
  methods: {
    handleSavedExpense(id) {
      this.selectedExpense.id = id;
      this.getExpensesOrExpenseGroups();
    },
    getExpensesOrExpenseGroups(printTable = false) {
      if (this.$route.query.filter) {
        return this.getExpenses(printTable);
      } else {
        return this.getExpenseGroups(printTable);
      }
    },
    getExpenses(printTable = false) {
      const filter = this.$route.query.filter ?? null;
      const offset = this.metaData && filter ? this.$refs.table.from : 0;
      const limit =
        this.metaData && filter ? this.$refs.table.pagination.perPage : 1000;
      const sortBy =
        this.metaData && filter ? this.$refs.table.currentSort : 'dateSigned';
      const sortOrder =
        this.metaData && filter ? this.$refs.table.currentSortOrder : 'desc';
      const columns = this.metaData ? this.$refs.chart.columns : 12;
      const mode = this.metaData ? this.$refs.chart.mode : 'Bar';

      api
        .get(services.expenses.getExpenses, {
          loadExpenses: true,
          group: !filter ? this.selectedGroup : null,
          params: this.filterParams,
          offset,
          limit,
          sortBy,
          sortOrder,
          filter: this.$route.query.filter ? this.$route.query.filter : null,
          columns,
          mode,
          printTable,
        })
        .then(data => {
          this.expenses = data.data;
          if (filter) {
            if (data.metaData) this.metaData = data.metaData;
            if (data.metaData.labels)
              this.functionData.labels = data.metaData.labels;
            if (data.metaData.data)
              this.functionData.series = data.metaData.data;
            if (data.metaData.legend)
              this.functionData.legend = data.metaData.legend;
            if (this.$refs.chart) this.$refs.chart.updateChart();
          }
        })

        .catch(error => {
          this.alertError(error);
        });
    },
    getExpenseGroups(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.metaData
        ? this.$refs.table.currentSort
        : 'dateSigned';
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : null;
      const columns = this.metaData ? this.$refs.chart.columns : 12;
      const mode = this.metaData ? this.$refs.chart.mode : 'Bar';
      api
        .get(services.expenses.getExpenseGroups, {
          getExpenseGroups: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          filter: this.$route.query.filter ?? null,
          columns,
          mode,
          printTable,
        })
        .then(data => {
          this.expenseGroups = data.data;
          this.metaData = data.metaData;
          if (this.selectedGroup) this.getExpenses();
          if (data.metaData.labels)
            this.functionData.labels = data.metaData.labels;
          if (data.metaData.data) this.functionData.series = data.metaData.data;
          if (data.metaData.legend)
            this.functionData.legend = data.metaData.legend;
          if (this.$refs.chart) this.$refs.chart.updateChart();
        })

        .catch(error => {
          this.alertError(error);
        });
    },
    updateInvoiceCheck(checked) {
      if (checked.find(el => el === true)) this.canGeneratePayments = true;
      else this.canGeneratePayments = false;
      checked.forEach((el, index) => {
        if (el && index !== 0) {
          if (this.expenses[index - 1].direction === 'out')
            this.canGeneratePayments = false;
        }
      });
    },
    openExpense(value) {
      const id = value.id;
      if (value.rowType === 'group') {
        this.expenses = [];
        this.selectedGroup = id.slice(1);
        this.getExpenses();
      } else if (value.numberOfRows === 'expense') {
        if (this.$route.query.filter)
          this.$router.push({
            path: 'expenses',
            query: { id, filter: this.$route.query.filter },
          });
        else this.$router.push({ path: 'expenses', query: { id } });
        this.getExpenseParams();
      }
    },
    getExpenseParams() {
      api
        .get(services.expenses.getExpenseParams, {
          loadExpense: true,
          expenseId: this.$route.query.id,
        })
        .then(data => {
          this.selectedExpense = data;
        })
        .catch(error => {
          this.alertError(error);
        });
      this.$smoothScroll({
        scrollTo: this.$refs.expenseContainer,
        hash: '#sampleHash', // required if updateHistory is true
      });
    },
    shouldShowLink(item) {
      return !!item.documentUrl;
    },
    openDocumentUrl(item) {
      window.open(item.documentUrl, '_blank');
    },
    deleteExpenses(items) {
      const ids = items.map(el => el.id);
      return Swal.fire({
        title: 'Obriši fakture',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'fakturu',
          'fakture',
          'faktura',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši fakture?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'fakturu',
                  'fakture',
                  'faktura',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then(data => {
            if (data.value) {
              api
                .post(services.expenses.deleteExpenses, {
                  deleteExpenses: true,
                  ids,
                })
                .then(() => {
                  this.getExpensesOrExpenseGroups();
                  this.$refs.table.removeChecked();
                })
                .catch(error => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },

    generatePayments(items) {
      const ids = items.map(el => el.id);
      return Swal.fire({
        title: 'Generiši isplate?',
        text: `Da li ste sigurni da želite da generišete ${ids.length} ${cases(
          ids.length,
          'isplatu',
          'isplate',
          'isplata',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-primary btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Generiši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Generiši isplate?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'zaduženje',
                  'zaduženja',
                  'zaduženja',
                )} za generisanje isplata. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-primary btn-fill',
                confirmButtonText: 'Generiši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then(data => {
            if (data.value) {
              api
                .post(services.payments.generatePayments, {
                  generatePayments: true,
                  ids,
                })
                .then(() => {
                  this.getExpenses();
                  this.$refs.table.removeChecked();
                })
                .catch(error => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    hideExpense() {
      this.selectedExpense = null;
    },
    generateSalaryCheckes() {
      return Swal.fire({
        title: 'Generiši zaduženja za plate',
        text: `Da li ste sigurni da želite da generišete ${this.metaData.totalSalary} zaduženja?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: 'Generiši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          api
            .post(services.expenses.generateSalaryCheckes, {
              generateSalaryCheckes: true,
            })
            .then(() => {
              this.getExpenses();
            })
            .catch(error => {
              this.alertError(error);
            });
        }
      });
    },
    registerExpense() {
      const date = new Date(Date.now()).toJSON().replace(/T.*/, '');

      this.selectedExpense =
        this.$route.query.filter && this.$route.query.filter === 'salary'
          ? {
              id: null,
              dateSigned: date,
              invoiceNumber: null,
              client: {
                id: null,
                name: null,
              },
              paymentType: 'cash',
              expenseTypeId: null,
              amountToPay: null,
              direction: 'in',
              vat: 0.0,
              notVat: false,
              comment: null,
              material: null,
            }
          : {
              id: null,
              dateSigned: date,
              invoiceNumber: null,
              client: {
                id: null,
                name: null,
              },
              paymentType: 'invoice',
              expenseTypeId: null,
              amountToPay: null,
              direction: 'in',
              vat: 0.21,
              notVat: false,
              comment: null,
              material: {
                materialTypeId: null,
                id: null,
                label: null,
                group: null,
                amount: null,
              },
            };
    },
  },
  mounted() {
    this.getExpensesOrExpenseGroups();
    if (this.$route.query && this.$route.query.id) this.getExpenseParams();
  },
  watch: {
    $route() {
      this.getExpensesOrExpenseGroups();
    },
    'metaData.columnParams': {
      handler(to, from) {
        if (to && (!from || to.length !== from.length)) {
          // this.reloading++;
          this.selectedExpense = null;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.align-right {
  text-align: right;
}
.offset-25 {
  margin-left: 25%;
}
.more-padding {
  padding: 1em 3em;
}
.tim-note {
  width: 100%;
  text-align: right;
  display: block;
}
.balance-display {
  margin-right: 3em;
}
</style>
